import { observable } from 'mobx'

import { SharingMode } from '~/client/graph'
import { GetCalendarConfigurationDocument } from '~/client/graph/operations/generated/CalendarConfiguration.generated'
import GraphExecutorStore from '~/client/src/shared/stores/domain/GraphExecutor.store'

export default class ActionPickerStore {
  @observable public isDisabled: boolean = false
  @observable public isFormsExternalCalendarDisabled: boolean = false
  @observable public isDeliveriesExternalCalendarDisabled: boolean = false

  public constructor(
    private readonly graphExecutorStore: GraphExecutorStore,
    private readonly projectId: string,
  ) {}

  public fetchData = async () => {
    try {
      const calendarConfigurationQuery = await this.graphExecutorStore.query(
        GetCalendarConfigurationDocument,
        { projectId: this.projectId },
      )

      const { calendarFormSharingMode, calendarDeliverySharingMode } =
        calendarConfigurationQuery.data.getCalendarConfiguration

      this.isFormsExternalCalendarDisabled =
        calendarFormSharingMode === SharingMode.AllInDateRange

      this.isDeliveriesExternalCalendarDisabled =
        calendarDeliverySharingMode === SharingMode.AllInDateRange
    } catch (error) {
      console.error(
        'Error occurred while fetching data in ActionPickerStore:',
        error,
      )
    }
  }
}
